import { __ } from "src/libs/utilities"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { PanelData } from "../../../UIX/interface"
import Panel from "../../../UIX/Panel"
import SingleCardFieldPanelContent from "./SingleCardFieldPanelContent"

/* Protopia Ecosystem component */
export interface ICardFieldEditorPanelProps {
   
}
const SingleCardFieldPanel = (props: ICardFieldEditorPanelProps): JSX.Element => {
    const { cardFieldSinglePositions, selectedCardField }	= useLandingStore((state: ILandingStore) => state)  
    const onPosition = ( x:number, y: number, w: number, h: number ) => {
        useLandingStore.setState({cardFieldSinglePositions:{ x, y, w, h }})
    }
    return !!selectedCardField 
        ?
        <Panel 
            x={ cardFieldSinglePositions?.x }
            y={ cardFieldSinglePositions?.y }
            w={ cardFieldSinglePositions?.w }
            h={ cardFieldSinglePositions?.h }
            isOpen={true}
            id="landing-single-card-field"
            onClose={() => useLandingStore.setState({ selectedCardField: null })}
            onPosition={onPosition}
            data={{
                title: __( selectedCardField.type ),
                icon: "/assets/img/landing/rows.svg",
                data: <SingleCardFieldPanelContent {...props} />
            } as PanelData}
        />
        :
        <></>
}
export default SingleCardFieldPanel